/** Lustro `PlannedTransactionKind` — rodzaj pozycji harmonogramu. */
export enum PlannedTransactionKind {
  /** Rata — należność klienta, kwota dodatnia. */
  INSTALLMENT = 'INSTALLMENT',
  /** Korekta należności z paczki zmian — dowolny znak. */
  CORRECTION = 'CORRECTION',
  /** Planowana wypłata do klienta; kwota ujemna i poza należnością. */
  REFUND = 'REFUND',
}
